import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from '@weezevent/nacre';
import GalleryModal from '../../../components/gallery';
import { FileContext } from './uploadImageZoneGemino';

export default function AddSocial({ organization, event, removeSocial = () => {}, onUpload = () => {}, onCancel = () => {}, image = null }) {
    const { t } = useTranslation();

    const [isOpenSocialModal, setOpenSocialModal] = React.useState(false);

    const onSelectedSocial = data => {
        setOpenSocialModal(false);
        onUpload(data);
    };

    const onCloseSocial = () => {
        setOpenSocialModal(false);
        onCancel();
    };

    return (
        <React.Fragment>
            <FileContext.Provider value={{ fileType: 'image', args: { blockType: 'social' } }}>
                <GalleryModal
                    apiKeyUnsplash={window.weezConfig.unsplash}
                    onSelected={onSelectedSocial}
                    onUpload={onSelectedSocial}
                    organization={organization}
                    event={event}
                    isOpenModal={isOpenSocialModal}
                    onClose={onCloseSocial}
                    maxSize={5242880}
                />
            </FileContext.Provider>
            <div className="add-social-container">
                {image ? (
                    <>
                        <img alt="Social" src={image} className="add-social-image" />
                        <div className="dropzone-container-cta">
                            <div className="dropzone-button" onClick={() => setOpenSocialModal(true)}>
                                {t('ticket.common.action.edit')}
                            </div>
                            <div className="dropzone-button-separator">|</div>
                            <div
                                className="dropzone-button"
                                onClick={() => {
                                    removeSocial();
                                }}
                            >
                                {t('ticket.common.action.delete')}
                            </div>
                        </div>
                    </>
                ) : (
                    <Button onClick={() => setOpenSocialModal(true)}>{t('ticket.event.minisite.add-social')}</Button>
                )}
            </div>
        </React.Fragment>
    );
}

AddSocial.propTypes = {
    organization: PropTypes.object.isRequired,
    onUpload: PropTypes.func,
    removeSocial: PropTypes.func,
    fileTypes: PropTypes.array,
    onCancel: PropTypes.func,
    image: PropTypes.string
};

AddSocial.fileTypes = ['jpg', 'jpeg', 'png', 'gif'];
